<h1>Murano Fantasy</h1>
<p><a href="murano-fantasy/">Murano Fantasy</a> is the second NFT collection published by Pandelune.</p>
<a href="murano-fantasy/">
  <img
    src="../murano-fantasy/img/gen/0xecc8dbf392379f08719a5a6e6a5ed3ac4d59c3956df0c496d09a719ba724662c.png"
    alt="Murano Fantasy by Pandelune"
  />
</a>
